import {
   handleIntersectionObserver,
   handleMobileMenu,
   hideMobileMenu,
   recalc,
   runBlocks,
} from './_functions'
import lozad from 'lozad'
const { $ } = window
const $body = $(document.body)

export default {
   // JavaScript to be fired on all pages
   init() {
      const observer = lozad(document.querySelectorAll('img')) // lazy loads elements with default selector as '.lozad'
      // // const observer = lozad('.lozad', {
      // const observer = lozad('document.querySelectorAll('img')', {
      //    rootMargin: '10px 0px', // syntax similar to that of CSS Margin
      //    threshold: 0.1, // ratio of element convergence
      //    enableAutoReload: true, // it will reload the new image when validating attributes changes
      // })
      observer.observe()

      handleMobileMenu()

      var x = window.matchMedia('(min-width: 1024px)') //lg
      hideMobileMenu(x)
      x.addEventListener('change', function () {
         hideMobileMenu(x)
      })

      document.addEventListener('DOMContentLoaded', function () {
         window.addEventListener('load', recalc)
         window.addEventListener('resize', recalc)
      })

      $(`.site-header--site-search`).on(`click`, function () {
         $(`.search-bar`).toggleClass(`open`)
      })

      handleIntersectionObserver()

      runBlocks()
   },
   // JavaScript to be fired on all pages, after page specific JS is fired
   finalize() {
      // class to hide outlines if not using keyboard
      $body.on('mousedown', function () {
         $body.addClass('using-mouse')
      })
      $body.on('keydown', function () {
         $body.removeClass('using-mouse')
      })

     
      let contactFormWrapper = document.getElementsByClassName('site-footer--subscribe')[0];
      let contactPageForm = document.getElementsByClassName('wpcf7-submit')[0];
      let grjs_loaded = false;

      if(contactFormWrapper || contactPageForm) {
         let observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
               if(entry.isIntersecting) {
                  if (!grjs_loaded) {
                     var script = document.createElement('script');
                     script.src = 'https://www.google.com/recaptcha/api.js?render=6LfFWR8gAAAAAPLW7Hw8yudPoKEq8PoiqtcvsYMy&amp;ver=3.0';
                     document.head.appendChild(script);
                     // Once the script is loaded, disconnect the observer
                     observer.disconnect();
                     grjs_loaded = true;
                  }
                }
            });
         });
         observer.observe(contactFormWrapper);
         observer.observe(contactPageForm);
       }
   },
}
